export default __webpack_public_path__ + "media/images/mailer/icon_flag-23f0e4d497969ec39db6e624fa418c9f.png";